<template>
  <div v-if="!requisicoes.finalizado" class="loading-overlay">
    <div class="spinner"></div>
  </div>

  <div v-if="requisicoes.finalizado">
    <!-- Banner Suitability -->
    <div v-if="!Edicao" class="suitability-banner">
      <div class="suitability-banner__content">
        <h3 class="suitability-banner__title">
          {{ tituloBannerSuitability }}
        </h3>

        <p class="suitability-banner__description">
          {{ descricaoBannerSuitability }}
          <span class="required-marker">*</span>
        </p>
      </div>

      <!-- Preservar as condições atuais -->
      <div class="suitability-banner__action">
        <span
          v-if="dadosUsuario.NecessarioRefazerSuitability"
          class="badge-novo-questionario"
        >
          Novo questionário
        </span>
        <button
          v-if="podeRefazerQuestionario && !temDispensaAtiva"
          type="button"
          class="btn-primary"
          @click="abrirQuestionario"
        >
          Refazer questionário
        </button>
        <button
          v-else-if="dadosUsuario.PerfilRisco == '' && !temDispensaAtiva"
          type="button"
          class="btn-primary"
          @click="abrirQuestionario"
        >
          Preencher questionário
        </button>
      </div>
    </div>

    <!-- Seção Questionário de perfil investidor -->
    <section v-if="!bloquearDispensaQuestionario" class="suitability-question">
      <header class="suitability-question__header">
        <h3>Questionário de perfil investidor</h3>
        <p>
          Obrigatório — responda ou informe o motivo da dispensa
          <span class="required-marker">*</span>
        </p>
      </header>

      <fieldset class="suitability-choice">
        <legend>
          Como deseja prosseguir?
          <span class="required-marker">*</span>
        </legend>

        <div class="suitability-choice__list">
          <!-- Opção: Responder o questionário -->
          <label
            class="suitability-option-card"
            :class="{ 'is-selected': !dispensar || dispensar === 'false' }"
          >
            <input
              type="radio"
              name="OpcaoSuitability"
              value="false"
              v-model="dispensar"
              @change="abrirModalDispensa"
            />

            <span class="suitability-option-card__content">
              <strong>Responder o questionário</strong>
              <small>
                Preencha as perguntas para definir seu perfil e ter acesso aos
                produtos adequados
              </small>
            </span>
          </label>

          <!-- Opção: Solicitar dispensa -->
          <label
            class="suitability-option-card"
            :class="{ 'is-selected': dispensar == true || dispensar == 'true' }"
          >
            <input
              type="radio"
              name="OpcaoSuitability"
              value="true"
              v-model="dispensar"
              @change="abrirModalDispensa"
            />

            <span class="suitability-option-card__content">
              <strong>Solicitar dispensa</strong>
              <small>
                Selecione o motivo pelo qual o questionário não se aplica à sua
                situação
              </small>
            </span>
          </label>
        </div>
      </fieldset>

      <!-- Motivo da dispensa -->
      <div
        v-if="dispensar == true || dispensar == 'true'"
        class="suitability-dispensation-reason"
      >
        <label
          class="form-field-label form-field-label-required"
          for="motivoDispensaQuestionario"
          >Motivo da dispensa do questionário *</label
        >
        <select
          id="motivoDispensaQuestionario"
          @change="alterarDispensa"
          v-model="dispensaQuestionario.MotivoDispensaQuestionarioId"
          class="field"
        >
          <option value="">Selecione</option>
          <option
            v-for="item in listaMotivosDispensa"
            :key="item.Id"
            :value="item.Id"
          >
            {{ item.Descricao }}
          </option>
        </select>
      </div>
    </section>

    <!-- Seção Produtos -->
    <section v-if="deveExibirProdutos" class="suitability-products">
      <div class="form-section-header">
        <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100">
          Produtos
        </h3>
        <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Preencha o questionário Suitability para ter acesso aos melhores
          produtos de acordo com o seu perfil.
        </p>
      </div>

      <div
        class="form-section-content"
        v-if="produtosFiltrados && produtosFiltrados.length > 0"
      >
        <!-- Desktop Table -->
        <div
          class="hidden md:block border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden"
        >
          <table class="w-full">
            <thead class="bg-gray-50 dark:bg-slate-800">
              <tr>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider"
                >
                  Nome do produto
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider"
                >
                  CNPJ
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider"
                >
                  Perfil
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider"
                >
                  Vigência
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider"
                >
                  Ações
                </th>
              </tr>
            </thead>
            <tbody
              v-if="dadosUsuario.PerfilRisco != ''"
              class="bg-white dark:bg-slate-900 divide-y divide-gray-200 dark:divide-slate-700"
            >
              <tr
                v-for="(produto, index) in produtosFiltrados"
                :key="index"
                class="hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors"
              >
                <td
                  class="px-4 py-3 text-sm font-medium text-gray-900 dark:text-gray-100"
                >
                  {{ produto.Descricao }}
                </td>
                <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                  {{ produto.Cnpj != null ? formatCpfCnpj(produto.Cnpj) : "" }}
                </td>
                <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                  {{ produto.PerfilNome }}
                </td>
                <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                  {{
                    produto.Vigencia > 0 ? produto.Vigencia : "Não se aplica"
                  }}
                </td>
                <td class="px-4 py-3 text-sm">
                  <div class="flex gap-2">
                    <button
                      v-if="
                        !listaProdutosCliente.some(
                          (produtoCliente) =>
                            produtoCliente.ProdutoId === produto.ProdutoId &&
                            produtoCliente.Aceite == true,
                        ) && this.nomeEmpresa != 'ACTUAL'
                      "
                      @click="lerTermos(produto.ProdutoId)"
                      class="px-3 py-1.5 text-xs font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
                    >
                      Ler os termos
                    </button>
                    <button
                      v-if="
                        !listaProdutosCliente.some(
                          (produtoCliente) =>
                            produtoCliente.ProdutoId === produto.ProdutoId &&
                            produtoCliente.Aceite == true,
                        ) && this.nomeEmpresa == 'ACTUAL'
                      "
                      @click="lerTermos(produto.ProdutoId)"
                      class="px-3 py-1.5 text-xs font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
                    >
                      Pendente de assinatura
                    </button>
                    <button
                      v-if="
                        listaProdutosCliente.some(
                          (p) =>
                            p.ProdutoId == produto.ProdutoId &&
                            p.Aceite == true,
                        )
                      "
                      disabled
                      class="px-3 py-1.5 text-xs font-medium text-white bg-blue-400 dark:bg-blue-500 rounded-lg cursor-not-allowed opacity-75"
                    >
                      Produto Adquirido
                    </button>
                    <button
                      v-if="
                        listaProdutosCliente.some(
                          (produtoCliente) =>
                            produtoCliente.ProdutoId === produto.ProdutoId &&
                            produtoCliente.Aceite == true,
                        )
                      "
                      @click="visualizarTermos(produto.ProdutoId)"
                      class="px-3 py-1.5 text-xs font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
                    >
                      Ver mais
                    </button>
                    <button
                      v-if="produto.TemDocumentos"
                      @click="abrirDocumentos(produto)"
                      class="px-3 py-1.5 text-xs font-medium text-white bg-green-600 dark:bg-green-700 rounded-lg hover:bg-green-700 dark:hover:bg-green-800 transition-colors"
                      title="Documentos"
                    >
                      Visualizar anexos
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile Cards -->
        <div class="md:hidden space-y-3">
          <template v-for="(produto, index) in produtosFiltrados" :key="index">
            <div
              v-if="produto.Descricao && dadosUsuario.PerfilRisco != ''"
              class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 space-y-3 bg-white dark:bg-slate-800"
            >
              <div>
                <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">
                  Descrição
                </p>
                <p class="text-sm font-medium text-gray-900 dark:text-gray-100">
                  {{ produto.Descricao }}
                </p>
              </div>

              <div>
                <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">
                  CNPJ
                </p>
                <p class="text-sm text-gray-700 dark:text-gray-300">
                  {{ produto.Cnpj != null ? formatCpfCnpj(produto.Cnpj) : "" }}
                </p>
              </div>

              <div>
                <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">
                  Perfil
                </p>
                <p class="text-sm text-gray-700 dark:text-gray-300">
                  {{ produto.PerfilNome }}
                </p>
              </div>

              <div>
                <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">
                  Vigência
                </p>
                <p class="text-sm text-gray-700 dark:text-gray-300">
                  {{
                    produto.Vigencia > 0 ? produto.Vigencia : "Não se aplica"
                  }}
                </p>
              </div>

              <div class="flex flex-col gap-2 pt-2">
                <button
                  v-if="
                    !listaProdutosCliente.some(
                      (produtoCliente) =>
                        produtoCliente.ProdutoId === produto.ProdutoId &&
                        produtoCliente.Aceite == true,
                    ) && this.nomeEmpresa != 'ACTUAL'
                  "
                  @click="lerTermos(produto.ProdutoId)"
                  class="w-full px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
                >
                  Ler os termos
                </button>
                <button
                  v-if="
                    !listaProdutosCliente.some(
                      (produtoCliente) =>
                        produtoCliente.ProdutoId === produto.ProdutoId &&
                        produtoCliente.Aceite == true,
                    ) && this.nomeEmpresa == 'ACTUAL'
                  "
                  @click="lerTermos(produto.ProdutoId)"
                  class="w-full px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
                >
                  Pendente de assinatura
                </button>
                <button
                  v-if="
                    listaProdutosCliente.some(
                      (p) =>
                        p.ProdutoId == produto.ProdutoId && p.Aceite == true,
                    )
                  "
                  disabled
                  class="w-full px-4 py-2 text-sm font-medium text-white bg-blue-400 dark:bg-blue-500 rounded-lg cursor-not-allowed opacity-75"
                >
                  Produto Adquirido
                </button>
                <button
                  v-if="
                    listaProdutosCliente.some(
                      (produtoCliente) =>
                        produtoCliente.ProdutoId === produto.ProdutoId &&
                        produtoCliente.Aceite == true,
                    )
                  "
                  @click="visualizarTermos(produto.ProdutoId)"
                  class="w-full px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
                >
                  Ver mais
                </button>
                <button
                  v-if="produto.TemDocumentos"
                  @click="abrirDocumentos(produto)"
                  class="w-full px-4 py-2 text-sm font-medium text-white bg-green-600 dark:bg-green-700 rounded-lg hover:bg-green-700 dark:hover:bg-green-800 transition-colors"
                  title="Documentos"
                >
                  📎 Documentos
                </button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </section>

    <ModalQuestionario />
    <ModalProdutos />
    <ModalDocumentosProduto />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalQuestionario from "../Questionario/ModalQuestionario.vue";
import ModalProdutos from "../Produtos/ModalInformativoProdutos.vue";
import ModalDocumentosProduto from "@/components/ModalDocumentosProduto.vue";
import formatCpfCnpj from "@/utils/formatCpfCnpj";

export default {
  name: "CadastroPF_Produtos",
  props: ["Edicao", "nomeAbaProdutos"],
  mixins: [formatCpfCnpj],
  components: { ModalQuestionario, ModalProdutos, ModalDocumentosProduto },
  computed: {
    ...mapGetters({
      user: "auth/user",
      listaProdutos: "GET_LISTA_PRODUTOS",
      listaProdutosCliente: "GET_LISTA_PRODUTOS_CLIENTE",
      perfilCliente: "GET_PERFIL_CLIENTE",
      listaMotivosDispensa: "GET_LISTA_MOTIVO_DISPENSA",
      infoObjDispensa: "GET_PF_PJ_SALVAR_INFO_DISPENSA",
      infoDispensaQuestionario: "GET_PF_PJ_INFO_DISPENSA_QUESTIONARIO",
      configDispensaQuestionario: "GET_DISPENSA_QUESTIONARIO",
      perfilSuitabilityPreview: "GET_SUITABILITY_PREVIEW",
      getConfiguracoes: "GET_CONFIGURACOES",
      getModalQuestionario: "GET_MODAL_QUESTIONARIO",
    }),
    produtosFiltrados() {
      if (this.getModalQuestionario) {
        return [];
      } else if (this.nomeEmpresa != "ACTUAL") {
        return this.listaProdutos;
      } else if (this.nomeEmpresa == "ACTUAL" && !this.Edicao) {
        return [];
      } else if (this.nomeEmpresa == "ACTUAL" && this.Edicao) {
        return this.listaProdutos.filter((produto) =>
          this.listaProdutosCliente.some(
            (produtoCliente) => produtoCliente.ProdutoId === produto.ProdutoId,
          ),
        );
      } else {
        return [];
      }
    },
    tituloBannerSuitability() {
      if (this.dadosUsuario.PerfilRisco) {
        return `Resultado: ${this.dadosUsuario.PerfilRisco}`;
      }

      if (
        this.dispensar === true ||
        this.dispensar === "true" ||
        this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0
      ) {
        return "Resultado: Dispensa Questionário";
      }

      return "Suitability";
    },
    descricaoBannerSuitability() {
      if (this.dadosUsuario.PerfilRisco) {
        return "Você respondeu o questionário de perfil investidor.";
      }

      if (
        this.dispensar === true ||
        this.dispensar === "true" ||
        this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0
      ) {
        return "Você solicitou a dispensa do questionário de perfil investidor.";
      }

      return "Para prosseguir, você precisa responder o questionário de perfil investidor ou informar o motivo pelo qual ele não se aplica à sua situação.";
    },
    temDispensaAtiva() {
      return (
        this.dispensar == true ||
        this.dispensar == "true" ||
        this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0
      );
    },
    podeRefazerQuestionario() {
      return (
        (this.dadosUsuario.PerfilRisco != "" ||
          this.perfilSuitabilityPreview?.Id > 0) &&
        !this.Edicao
      );
    },
    deveExibirProdutos() {
      return (
        !this.isInstitucional &&
        (this.configuracaoProdutosExibidosNoFinalCadastro ||
          this.Edicao == true)
      );
    },
  },
  data() {
    return {
      configuracaoProdutosExibidosNoFinalCadastro: false,
      requisicoes: {
        listaProdutos: false,
        perfilCliente: false,
        listaProdutosCliente: false,
        configDispensaQuestionario: false,
        finalizado: false,
      },
      bloquearDispensaQuestionario: false,
      nomeEmpresa: "",
      dispensarAnterior: false,
      dispensar: false,
      dispensaQuestionario: {
        MotivoDispensaQuestionarioId: "",
        DataQuestionario: null,
      },
      filtroPerfilNome: "",
      permitirAvancar: true,
      produtosCliente: [],
      dadosUsuario: {
        PerfilRisco: "",
      },
    };
  },
  async created() {
    if (!this.Edicao) {
      this.$store.dispatch("FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE");
    }

    await this.fetchConfiguracao([
      "Exibição termos dos produtos",
      "Produtos exibidos no final do cadastro externo",
    ]);

    this.configuracaoProdutosExibidosNoFinalCadastro =
      this.getConfiguracoes("Produtos exibidos no final do cadastro externo")
        ?.Valor == "N"
        ? false
        : true;

    this.$store.dispatch("FETCH_PERFIL_CLIENTE");
    this.$store.dispatch("FETCH_BUSCA_LISTA_MOTIVO_DISPENSA");
    this.$store.dispatch("FETCH_VERIFICAR_DISPENSA_QUESTIONARIO");
  },
  mounted() {
    this.$store.dispatch("FETCH_DISPENSA_QUESTIONARIO");
    this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
    this.$store.commit("SET_PERFIL_CLIENTE", null);

    this.verificarConfigDispensaQuestionario();
    this.verificarSeRequisicoesFinalizaram("listaProdutosCliente");
    if (this.listaProdutosCliente != null) {
      this.produtosCliente = this.listaProdutosCliente;
    }
    this.verificarSeRequisicoesFinalizaram("listaProdutos");
    this.verificarPerfilCliente();
    this.verificarConfigDispensaQuestionario();

    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    if (this.infoObjDispensa == null) {
      this.dispensaQuestionario = this.infoDispensaQuestionario;
      if (this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0) {
        this.dispensar = true;
        this.dispensarAnterior = true;
      } else {
        this.dispensar = false;
        this.dispensarAnterior = false;
      }
    }
  },
  watch: {
    perfilSuitabilityPreview() {
      this.obterProdutos();
    },
    configDispensaQuestionario() {
      this.verificarConfigDispensaQuestionario();
    },
    infoDispensaQuestionario() {
      this.dispensaQuestionario = this.infoDispensaQuestionario;
      if (this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0) {
        this.dispensar = true;
        this.dispensarAnterior = true;
      } else {
        this.dispensar = false;
        this.dispensarAnterior = false;
      }
    },
    listaProdutosCliente() {
      this.verificarSeRequisicoesFinalizaram("listaProdutosCliente");
      this.produtosCliente = this.listaProdutosCliente;
    },
    listaProdutos() {
      this.verificarSeRequisicoesFinalizaram("listaProdutos");
    },
    perfilCliente() {
      this.verificarPerfilCliente();
    },
  },
  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    obterProdutos() {
      if (this.perfilSuitabilityPreview?.Id > 0) {
        this.$store.dispatch(
          "FETCH_CONSULTA_LISTA_PRODUTOS_PREVIEW",
          this.perfilSuitabilityPreview?.Id,
        );
      } else {
        this.$store.dispatch("FETCH_CONSULTA_LISTA_PRODUTOS");
      }
      this.$store.dispatch("FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE");
    },
    verificarPerfilCliente() {
      this.verificarSeRequisicoesFinalizaram("perfilCliente");
      if (this.perfilCliente)
        if (this.perfilCliente[0]) {
          this.dadosUsuario = this.perfilCliente[0];
          this.filtroPerfilNome = this.perfilCliente[0].PerfilRisco;

          if (
            this.dadosUsuario != null &&
            this.dadosUsuario.NecessarioRefazerSuitability
          ) {
            this.toast.add({
              severity: "warn",
              summary: "Atualização Necessária",
              detail:
                "Seu questionário de suitability precisa ser respondido novamente para continuidade do cadastro.",
              life: 3000,
            });
          }

          this.obterProdutos();
        } else if (!(this.perfilSuitabilityPreview?.Id > 0)) {
          this.filtroPerfilNome = "";
          this.dadosUsuario = {
            PerfilRisco: "",
            NecessarioRefazerSuitability: false,
          };
          this.$store.commit("SET_LISTA_PRODUTOS", []);
          this.$store.commit("SET_LISTA_PRODUTOS_CLIENTE", []);
        }
    },
    verificarConfigDispensaQuestionario() {
      this.verificarSeRequisicoesFinalizaram("configDispensaQuestionario");
      if (this.configDispensaQuestionario != null) {
        var configuracaoDispensa = this.configDispensaQuestionario.filter(
          (config) => config.Chave == "Dispensa do questionário",
        );
        if (configuracaoDispensa[0] != null) {
          if (configuracaoDispensa[0].Valor == "Não") {
            this.bloquearDispensaQuestionario = true;
          }
        }
      }
    },
    verificarSeRequisicoesFinalizaram(requisicao) {
      if (requisicao == "listaProdutos" || this.nomeEmpresa == "ACTUAL") {
        this.requisicoes.listaProdutos = true;
      } else if (requisicao == "perfilCliente") {
        this.requisicoes.perfilCliente = true;
      } else if (requisicao == "listaProdutosCliente") {
        this.requisicoes.listaProdutosCliente = true;
      } else if (requisicao == "configDispensaQuestionario") {
        this.requisicoes.configDispensaQuestionario = true;
      }
      if (
        (this.requisicoes.listaProdutos &&
          this.requisicoes.perfilCliente &&
          this.requisicoes.listaProdutosCliente &&
          this.requisicoes.configDispensaQuestionario) ||
        this.nomeEmpresa == "ACTUAL"
      ) {
        this.requisicoes.finalizado = true;
      }
    },
    abrirModalDispensa() {
      if (
        this.dispensarAnterior != this.dispensar &&
        this.dispensar == "false"
      ) {
        this.$alert({
          icon: "warning",
          title: "Remover dispensa de questionário",
          text: "Para realizar essa operação os produtos aderidos serão cancelados. Deseja seguir?",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
            this.alterarDispensa();
            this.abrirQuestionario();
          } else {
            this.dispensar = this.dispensarAnterior;
          }
        });
      } else {
        this.alterarDispensa();
      }
    },
    alterarDispensa() {
      const valorAnterior = this.dispensarAnterior;
      this.dispensarAnterior = this.dispensar;

      if (
        this.dispensar == "false" ||
        (this.dispensar &&
          this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0)
      ) {
        if (this.dispensar == "false") {
          this.dispensaQuestionario.MotivoDispensaQuestionarioId = "0";

          if (valorAnterior && valorAnterior !== "false") {
            this.$store.commit("SET_DISPENSA_QUESTIONARIO_REMOVIDA", true);
            this.$store.commit("REMOVE_ETAPA_CONCLUIDA", 9);
          }
        } else if (
          (this.dispensar == "true" || this.dispensar == true) &&
          this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0
        ) {
          this.$store.commit("SET_ETAPA_CONCLUIDA", 9);
          this.$store.commit("SET_SUITABILITY_PREVIEW", null);
          this.$store.commit("SET_DISPENSA_QUESTIONARIO_REMOVIDA", false);
        }
        this.salvarAlteracoesLocalmente();
        this.salvarInformacoes();
      } else {
        this.salvarAlteracoesLocalmente();
      }
    },
    abrirQuestionario() {
      // Limpar dispensa ao optsar por responder o questionário
      if (this.dispensar == true || this.dispensar == "true") {
        this.dispensarAnterior = this.dispensar;
        this.dispensar = false;
        this.dispensaQuestionario = {
          MotivoDispensaQuestionarioId: "",
          DataQuestionario: null,
        };
        // Em modo de edição, limpa o perfil de risco para permitir refazer
        // Em modo de preenchimento (!Edicao), mantém o perfil vazio para mostrar "Preencher questionário"
        if (this.Edicao && this.dadosUsuario.PerfilRisco != "") {
          this.dadosUsuario.PerfilRisco = "";
          this.dadosUsuario.NecessarioRefazerSuitability = false;
        }
        this.$store.commit("SET_DISPENSA_QUESTIONARIO_REMOVIDA", true);
        this.$store.commit("REMOVE_ETAPA_CONCLUIDA", 9);
        this.$store.commit("SET_LISTA_PRODUTOS", []);
        this.$store.commit("SET_PERFIL_CLIENTE", null);
        this.salvarAlteracoesLocalmente();
      }
      this.$store.commit("SET_MODAL_QUESTIONARIO", true);
    },
    lerTermos(id) {
      this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", id);
    },
    visualizarTermos(id) {
      this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", id);
      this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", true);
    },
    async abrirDocumentos(produto) {
      this.$store.commit("SET_MODAL_DOCUMENTOS_PRODUTO", {
        show: true,
        produtoId: produto.ProdutoId,
        produtoDescricao: produto.Descricao,
      });
      await this.$store.dispatch(
        "FETCH_CONSULTA_DOCUMENTOS_PRODUTO",
        produto.ProdutoId,
      );
    },
    async baixarDocumento(documentoId, fileName) {
      try {
        const response = await this.$store.dispatch(
          "FETCH_BAIXAR_DOCUMENTO_PRODUTO",
          documentoId,
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$alert({
          icon: "error",
          title: "Erro",
          text: "Não foi possível baixar o documento. Tente novamente.",
        });
      }
    },
    validarFormulario() {
      var mensagemAlerta =
        "Para a conclusão do cadastro, é necessário o preenchimento do questionário ou a dispensa do questionário.";
      if (this.bloquearDispensaQuestionario) {
        mensagemAlerta =
          "Para a conclusão do cadastro, é necessário o preenchimento do questionário";
      }

      var permitirAvancarLocal = true;

      if (
        this.dadosUsuario.NecessarioRefazerSuitability &&
        !(this.perfilSuitabilityPreview?.Id > 0)
      ) {
        this.$alert({
          icon: "error",
          title: "Concluir cadastro",
          text: "Para a conclusão do cadastro, seu questionário de suitability precisa ser respondido novamente.",
        });
        permitirAvancarLocal = false;
      }

      if (
        this.dadosUsuario.PerfilRisco == "" &&
        !(this.perfilSuitabilityPreview?.Id > 0)
      ) {
        this.$alert({
          icon: "error",
          title: "Concluir cadastro",
          text: mensagemAlerta,
        });
        permitirAvancarLocal = false;
      }

      this.permitirAvancar = permitirAvancarLocal;

      return this.permitirAvancar;
    },
    proximaEtapa() {
      if (this.validarFormulario()) {
        this.$store.commit("SET_FICHA_CONCLUIR", true);
        this.salvarInformacoes();
      }
    },
    salvarAlteracoesLocalmente() {
      this.$store.commit(
        "SET_PF_PJ_SALVAR_INFO_DISPENSA",
        this.dispensaQuestionario,
      );
    },
    salvarInformacoes() {
      this.$store.commit("SET_PF_SALVAR_INFO", true);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Suitability Page Card */
.suitability-page-card {
  overflow: hidden;
  border: 1px solid #dfe4ea;
  border-radius: 8px;
  background: #fff;

  @media (prefers-color-scheme: dark) {
    background: #1e293b;
    border-color: #334155;
  }
}

.suitability-page-content {
  padding: 24px;
}

/* Banner */
.suitability-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 20px;
  border: 1px solid #b9d5ff;
  border-radius: 8px;
  background: #eff6ff;

  @media (prefers-color-scheme: dark) {
    background: #1e3a5f;
    border-color: #3b82f6;
  }

  @media (max-width: 767px) {
    align-items: stretch;
    flex-direction: column;
  }
}

.suitability-banner__content {
  flex: 1;
}

.suitability-banner__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e40af;

  @media (prefers-color-scheme: dark) {
    color: #93c5fd;
  }
}

.suitability-banner__description {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;

  @media (prefers-color-scheme: dark) {
    color: #d1d5db;
  }
}

.suitability-banner__action {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;

  @media (max-width: 767px) {
    justify-content: flex-start;
  }
}

/* Question Section */
.suitability-question {
  margin-top: 20px;
}

.suitability-question__header {
  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #111827;

    @media (prefers-color-scheme: dark) {
      color: #f3f4f6;
    }
  }

  p {
    margin: 6px 0 0;
    font-size: 14px;
    color: #4b5563;

    @media (prefers-color-scheme: dark) {
      color: #9ca3af;
    }
  }
}

/* Choice Fieldset */
.suitability-choice {
  margin-top: 20px;
  padding: 0;
  border: 0;

  legend {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 500;
    color: #374151;

    @media (prefers-color-scheme: dark) {
      color: #d1d5db;
    }
  }
}

.suitability-choice__list {
  display: flex;
  width: 100%;
  max-width: 700px;
  flex-direction: column;
  gap: 16px;
}

/* Option Cards */
.suitability-option-card {
  display: flex;
  min-height: 68px;
  cursor: pointer;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 12px;
  border: 1px solid #cfd7e3;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.2s ease, background-color 0.2s ease,
    box-shadow 0.2s ease;

  @media (prefers-color-scheme: dark) {
    background: #1e293b;
    border-color: #475569;
  }

  input[type="radio"] {
    margin-top: 2px;
    accent-color: #2f6fed;
  }

  &:hover {
    border-color: #9dbbe8;
    background: #f8fbff;

    @media (prefers-color-scheme: dark) {
      background: #1e3a5f;
      border-color: #3b82f6;
    }
  }

  &:focus-within {
    outline: 2px solid #2f6fed;
    outline-offset: 2px;
  }

  &.is-selected {
    border-color: #2f6fed;
    background: #f1f6ff;

    @media (prefers-color-scheme: dark) {
      background: #1e3a5f;
      border-color: #3b82f6;
    }
  }
}

.suitability-option-card__content {
  display: flex;
  flex-direction: column;
  gap: 6px;

  strong {
    font-size: 14px;
    font-weight: 500;
    color: #111827;

    @media (prefers-color-scheme: dark) {
      color: #f3f4f6;
    }
  }

  small {
    color: #8a94a6;
    font-size: 11px;
    line-height: 1.4;

    @media (prefers-color-scheme: dark) {
      color: #9ca3af;
    }
  }
}

/* Dispensation Reason */
.suitability-dispensation-reason {
  width: 100%;
  max-width: 700px;
  margin-top: 20px;
}

/* Products Section */
.suitability-products {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;

  @media (prefers-color-scheme: dark) {
    border-top-color: #374151;
  }
}

/* Footer */
.suitability-page-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 74px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;

  @media (prefers-color-scheme: dark) {
    background: #0f172a;
    border-top-color: #374151;
  }

  @media (max-width: 767px) {
    align-items: stretch;
    flex-direction: column-reverse;
    padding: 16px;

    button {
      width: 100%;
    }
  }
}

/* Required Marker */
.required-marker {
  color: #dc2626;
  font-weight: 700;
}

/* Badge */
.badge-novo-questionario {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #f5a623;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Botão primário do banner - sempre azul */
.suitability-banner__action .btn-primary {
  background-color: #2563eb !important;
  border-color: #2563eb !important;
  color: #fff !important;
}

.suitability-banner__action .btn-primary:hover {
  background-color: #1d4ed8 !important;
  border-color: #1d4ed8 !important;
}
</style>
